import React from 'react'
import i18n from 'i18next';


const minuteDivider = 60 * 1000;
const hourDivider = 60 * 60 * 1000;
const dayDivider = 24 * 60 * 60 * 1000;


function msToTime(duration: number): string {
    const seconds = Math.floor(duration / 1000) % 60;
    const minutes = Math.floor(duration / minuteDivider) % 60;
    const hours = Math.floor(duration / hourDivider);

    const timeString = [hours, minutes, seconds].map(n => n.toString().padStart(2, '0')).join(':');
    const millisString = (duration % 1000).toString().padStart(3, '0');

    return `${timeString}.${millisString}`;
}

export const getDuration = (startedAt: string, modifiedAt: string): string => {
    
    const timestamp = Date.parse(modifiedAt) - Date.parse(startedAt);

    return msToTime(timestamp)
}
